module.exports = __webpack_public_path__ + "assets/078497b71ee4a435f59225de6356cded.png";